<script>
	import axios from "axios";
	import {replace} from "svelte-spa-router";
	import {documentos,cuenta} from "./store.js";
	let dev ="https://vps-1858514-x.dattaweb.com/veterinaria";
	let replication;
	async function actualizarDocumentos(){
		const allDocs = await db.allDocs({
			include_docs: true
		});
		console.log(allDocs);
		$documentos = allDocs.rows.map(row => row.doc);
	}
	async function sync(){
		replication = PouchDB.sync("data",dev,{
			auth:{
				username:"vete",password:"vete"
			},
			live: true,
			retry: true
		}).on("change",async (info)=>{
			console.log(info);
			console.log("conectando");
			await actualizarDocumentos();
		}).on("error",(err)=>{
			console.log("replication error",err);
		})
	}

	export function login(nombre,pass){
		return axios.get(`${dev}/cuenta:${nombre}`,{
			auth:{
				username:"vete",password:"vete"
			}
		}).then(async (res)=>{
			if (res.data.password == pass){
				$cuenta = res.data;
				await sync();
				await actualizarDocumentos();
				replace("/home");
			}
		}).catch((err)=>{
			console.log(err);
		})
	}
</script>
